/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import type { Filter } from '../../utils/filters';

export default class ReportingInventoryController extends Controller {
  queryParams = [
    'cluster',
    'filters',
    'sortingOrderBy',
    'pagination.page_size',
    'pagination.next_page_token',
    'pagination.previous_page_token',
  ];
  @tracked cluster: string = '';
  @tracked filters: Filter[] = [];
  @tracked pagination: {
    page_size: number;
    next_page_token: string | null;
    previous_page_token: string | null;
  } = {
    page_size: 10,
    next_page_token: null,
    previous_page_token: null,
  };
  @tracked sortingOrderBy: string[] = [];

  handleApplyFilter = (filters: Filter[]) => {
    this.filters = filters;
    // Reset pagination when filters change
    this.resetPagination();
  };

  resetPagination = () => {
    this.pagination = {
      page_size: 10,
      next_page_token: null,
      previous_page_token: null,
    };
  };

  handlePageChange = (pagination: {
    next_page_token: string | null;
    previous_page_token: string | null;
    page_size: number;
  }) => {
    this.pagination = pagination;
  };

  handleApplySort = (orderBy: string[]) => {
    this.sortingOrderBy = orderBy;
    this.resetPagination();
  };

  getClusterLinkParams = (cluster: string) => {
    return {
      filters: [],
      sortingOrderBy: [],
      pagination: {
        page_size: 10,
        next_page_token: null,
        previous_page_token: null,
      },
      cluster,
    };
  };
}
